const ServerAddress = "https://qardbe.etechcube.com/";
const BucketAddress = "https://development-local-erp-qrcode-barcode.s3.ap-south-1.amazonaws.com/";

export { ServerAddress , BucketAddress }; 
